import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import ParameterWithSimpleInput from '../inputs/ParameterWithSimpleInput'
import ParameterWithSwitch from '../inputs/ParameterWithSwitch'
import { Stack } from '@mui/material'
import { shallowEqual, useSelector } from 'react-redux'
import pluvioValidOnlyHelp from 'assets/pictures/observatory/pluvioValidOnlyHelp.webp'
import pluviometryHorizonsHelp from 'assets/pictures/observatory/pluviometryHorizonsHelp.webp'
import pluviometryLimitHistoHelp from 'assets/pictures/observatory/pluviometryLimitHistoHelp.webp'
import { INPUT_TYPES } from 'components/forms/SimpleInput'
import FrequencyDatas, { FREQUENCY_STATIONS_TYPES } from '../FrequencyDatas'
import { toUpper } from 'lodash'
import PluvioDataTypes from '../PluvioDataTypes'
import ShowDataTypesRules from '../ShowDataTypesRules'
import ParameterWithSuperMultiAutocomplete from '../inputs/ParameterWithSuperMultiAutocomplete'
import { getQualifications } from 'utils/QualityUtils'

const PluviometryParameters = ({
    isWidget = false,
    isGlobal = false,
    defaultProps = {},
}) => {
    const {
        pluviometryDataTypes,
    } = useSelector(store => ({
        pluviometryDataTypes: store.PluviometryReducer.pluviometryDataTypes,
    }), shallowEqual)

    return (
        <Stack spacing={1.25}>
            <ParameterWithSwitch
                {...defaultProps}
                parameter={isWidget ? 'pluvioValidOnlyWidget' : 'pluvioValidOnly'}
                title={i18n.validatedDataOnly}
                helpImage={pluvioValidOnlyHelp}
            />
            <ParameterWithSuperMultiAutocomplete
                {...defaultProps}
                parameter='pluvioQualificationType'
                options={getQualifications()}
                title={i18n.consideredQualificationType}
                keyValue='code'
                multiple
            />
            <ParameterWithSimpleInput
                {...defaultProps}
                parameter={isWidget ? 'pluviometryHorizonsWidget' : 'pluviometryHorizons'}
                title={i18n.chartHorizons}
                helpImage={pluviometryHorizonsHelp}
                placeholder='7,30,90,365,HISTO'
            />
            <ParameterWithSimpleInput
                {...defaultProps}
                parameter={isWidget ? 'pluviometryLimitHistoWidget' : 'pluviometryLimitHisto'}
                title={i18n.chartHistoryLimit}
                helpImage={pluviometryLimitHistoHelp}
                placeholder='265'
                type={INPUT_TYPES.int}
            />
            <FrequencyDatas module={isWidget ? null : toUpper(module.module)} stationType={FREQUENCY_STATIONS_TYPES.pluvio} {...defaultProps} />
            {!isWidget && <ShowDataTypesRules link='pluviometry/pluviometryOptions' {...defaultProps} />}
            <PluvioDataTypes
                {...defaultProps}
                pluviometryDataTypes={pluviometryDataTypes}
                isGlobal={isGlobal}
            />
        </Stack>
    )
}

PluviometryParameters.propTypes = {
    isWidget: PropTypes.bool,
    isGlobal: PropTypes.bool,
    defaultProps: PropTypes.shape({}),
}

export default PluviometryParameters
